<!-- Custom columns render the report-supplied template (its markup is copied
     verbatim from the report's old *ngSwitchCase blocks); every other column
     falls back to the shared generic cell. The host is display:contents (see
     the css) so this wrapper adds no element box — the rendered output matches
     the previous inline, skeleton-per-report markup. -->
<ng-container *ngIf="customColumns.includes(column); else notCustom">
  <ng-container *ngTemplateOutlet="customTemplate; context: { row: row, col: column }"></ng-container>
</ng-container>
<ng-template #notCustom>
  <app-generic-table-cell [content]="getContentItem(row, column)"
                          [column]="column"
                          [objectIDColumns]="objectIDColumns"
                          [currencyColumns]="currencyColumns"
                          [dateColumns]="dateColumns"></app-generic-table-cell>
</ng-template>
